// Numbri formaatimise abifunktsioonid (eesti et-EE locale)
// Vastavus parks_dashboard.py malliga: fmt() ja fmtKWh()

/**
 * Formaadib numbri eesti locale'iga, automaatse kümnendkohtade arvuga
 * (suuremad numbrid → vähem kohti).
 */
export function fmt(v, decimals) {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  if (decimals === undefined) {
    decimals = Math.abs(v) >= 100 ? 1 : Math.abs(v) >= 10 ? 2 : 3;
  }
  return v.toLocaleString('et-EE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/**
 * Formaadib energia: < 1000 kWh kuvame kWh, muidu MWh.
 */
export function fmtKWh(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  if (v >= 1000) return `${fmt(v / 1000, 2)} MWh`;
  return `${fmt(v, 1)} kWh`;
}

/**
 * Formaadib viimase uuenduse aja.
 */
export function fmtUpdatedAt(iso) {
  if (!iso) return '—';
  try {
    // Backend võib tagastada ISO ilma 'Z' suffixita — sel juhul tõlgendame
    // selle UTC-na (mitte kohaliku ajana, mis tekitab kõrvalekalde).
    const hasTz = /Z|[+-]\d{2}:?\d{2}$/.test(iso);
    const d = new Date(hasTz ? iso : iso + 'Z');
    return `Uuendatud ${d.toLocaleTimeString('et-EE')}`;
  } catch {
    return '—';
  }
}

/**
 * Formaadib seadme viimase uuenduse kellaaja: "14:23:05" või "14:23:05 (eile)" / "(2 päeva)".
 * Kasutab seadme objekti _updated_at välja.
 */
export function fmtAge(device) {
  if (!device || !device._updated_at) return '—';
  const d = new Date(device._updated_at);
  if (Number.isNaN(d.getTime())) return '—';
  const time = d.toLocaleTimeString('et-EE');
  // Lisa kuupäev kui andmed on vanemad kui täna
  const ageMs = Date.now() - d.getTime();
  if (ageMs < 86_400_000) {
    // < 24h — pole vaja kuupäeva
    return time;
  }
  const days = Math.floor(ageMs / 86_400_000);
  if (days === 1) return `${time} (eile)`;
  return `${time} (${days} päeva)`;
}

/**
 * Kas seade on online (värsked andmed)? Backend tagastab _online lipu.
 */
export function isDeviceOnline(device) {
  if (!device) return false;
  return device._online !== false;
}

/**
 * PCS staatuse koodi → eesti keeles staatuse nimi ja CSS klass.
 */
export const PCS_STATUS_MAP = {
  0:  ['Väljas', 'standby'],
  1:  ['Self-Check', 'standby'],
  2:  ['Töötab', 'charge'],
  4:  ['Viga', 'fault'],
  7:  ['Standby', 'standby'],
  10: ['Laeb', 'charge'],
  11: ['Tühjeneb', 'discharge'],
};

export function pcsStatusInfo(code) {
  return PCS_STATUS_MAP[code] || ['?', 'standby'];
}
